import React from 'react';
import AnimatedModal from './AnimatedModal';

interface AlterarIntegracaoModalProps {
  banca: any;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}

const AlterarIntegracaoModal: React.FC<AlterarIntegracaoModalProps> = ({ banca, onClose, onConfirm }) => {
  const [loading, setLoading] = React.useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await onConfirm();
      onClose();
    } catch (error) {
      console.error('Erro ao alternar integração:', error);
    } finally {
      setLoading(false);
    }
  };

  const novoEstado = banca.hasIntegracao ? 'desabilitar' : 'habilitar';

  return (
    <AnimatedModal isOpen={true} onClose={onClose}>
      <div style={{
        backgroundColor: 'white',
        padding: '30px',
        borderRadius: '8px',
        width: '400px',
        maxWidth: '90vw'
      }}>
        <h3 style={{ marginBottom: '20px' }}>Alternar Integração</h3>
        
        <p style={{ marginBottom: '20px' }}>
          Deseja {novoEstado} a integração desta banca?
        </p>

        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
          <button
            type="button"
            onClick={onClose}
            disabled={loading}
            style={{
              padding: '8px 16px',
              border: '1px solid #ddd',
              background: 'white',
              borderRadius: '4px',
              cursor: loading ? 'not-allowed' : 'pointer'
            }}
          >
            Cancelar
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            disabled={loading}
            style={{
              padding: '8px 16px',
              backgroundColor: '#28a745',
              color: 'white',
              border: '1px solid #28a745',
              borderRadius: '4px',
              cursor: loading ? 'not-allowed' : 'pointer'
            }}
          >
            {loading ? 'Alterando...' : 'Confirmar'}
          </button>
        </div>
      </div>
    </AnimatedModal>
  );
};

export default AlterarIntegracaoModal;
